import React, { Component } from 'react';
import { readAndDraw } from './d3-map';
import bg from '../resources/map/mall road map without text.jpg';
import styles from './css-modules/map.module.css';
import { withRouter } from 'react-router-dom'

class Map extends Component {

  componentDidMount() {
    readAndDraw(this.props.history);
  }

  render () {
    return (
      <div className={`${styles.mapContain}`}>
        <div className={`${styles.visContain} visContain`}>
          <div className={`${styles.tooltip_container} tooltip_container`}></div>
          <svg className ={`${styles.voronoi} voronoi`}  viewBox = "0 0 1068 675"></svg>
          <img id="map_background" alt="Lahore Mall Road Illustrated Map" className = {`${styles.mapBG} mapBG`} src={bg}/>
        </div>
      </div>
    )
  }
}

export default withRouter(Map);
